import { useState, useEffect } from 'react';
import { analytics } from '../../services/analytics';

const CookieConsent = () => {
	const [showConsent, setShowConsent] = useState(false);

	useEffect(() => {
		const consent = localStorage.getItem('cookie-consent');
		if (!consent) {
			setShowConsent(true);
		}
	}, []);

	const acceptCookies = () => {
		localStorage.setItem('cookie-consent', 'accepted');
		setShowConsent(false);
		// Re-initialize analytics now that consent is granted
		analytics.initialize();
	};

	const rejectCookies = () => {
		localStorage.setItem('cookie-consent', 'rejected');
		setShowConsent(false);
	};

	if (!showConsent) return null;

	return (
		<div
			className="cookie-consent"
			role="dialog"
			aria-label="Cookie consent"
			aria-modal="true"
		>
			<div className="cookie-consent-content">
				<p>
					We use cookies to enhance your browsing experience and analyze our
					traffic. By clicking "Accept", you consent to our use of cookies.
				</p>
				<div className="cookie-consent-buttons">
					<button
						onClick={acceptCookies}
						className="btn btn-primary"
						aria-label="Accept cookies"
					>
						Accept
					</button>
					<button
						onClick={rejectCookies}
						className="btn btn-secondary"
						aria-label="Reject cookies"
					>
						Reject
					</button>
				</div>
			</div>
		</div>
	);
};

export default CookieConsent;
